import { CircularProgress, Grid, Paper, Theme } from '@mui/material';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import AuthRequestStatus from '../../../enums/AuthRequestStatus';
import { MinimalPageLayout } from '../../Navigation/MinimalLayout/MinimalPageLayout';
import { StayInContactIcon } from '../StayInContactIcon';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: '100vw',
        height: '100vh',
        background: 'linear-gradient(180deg, rgba(4,58,107,1) 0%, rgba(0,48,84,1) 100%)',
    },
    icon: {
        maxWidth: '250px',
    },
}));

interface Params {
    status: AuthRequestStatus;
}

function getFriendlyStatus(status: AuthRequestStatus) {
    switch (status) {
        case AuthRequestStatus.none:
            return 'Initializing';
        case AuthRequestStatus.verify:
            return 'Authenticating';
        case AuthRequestStatus.active:
            return 'Loading Preferences';
        default:
            return 'Finalizing';
    }
}

export default function SplashScreen({ status }: Params) {
    const { classes } = useStyles();

    const friendlyStatus = React.useMemo(() => getFriendlyStatus(status), [status]);

    return (
        <MinimalPageLayout>
            <StayInContactIcon className={classes.icon} />
            <Paper sx={{ p: 3, textAlign: 'center' }}>
                <Grid container flexDirection="column" spacing={3} justifyContent="center">
                    <Grid item>
                        <CircularProgress />
                    </Grid>
                    <Grid item>
                        <Typography variant="h5">{friendlyStatus}</Typography>
                    </Grid>
                </Grid>
            </Paper>
        </MinimalPageLayout>
    );
}
